export interface GetAmbarAgreementSchemeListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetAmbarAgreementSchemeListPagingAndFilterResponseData
}

export interface GetAmbarAgreementSchemeListPagingAndFilterResponseData {
    items: GetAmbarAgreementSchemeListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetAmbarAgreementSchemeListPagingAndFilterResponseItem {
    ambarAgreementSchemeId: string
    companyId: string
    refNo: string
    name: string
    projectId: string
    carryTypeId: string
    regionId: string
    potTypeId: string
    isIncome: boolean
    isOutcome: boolean
    multiplierId: string
    intervalTypeId: any
    serviceId: any
    currencyTypeId: string
    isComplete: boolean
    isScale: boolean
    description: string
    isCustomActive: boolean
    isDynamicService: boolean
    projectName: string
    carryTypeName: string
    regionName: string
    potTypeName: string
    multiplierName: string
    intervalTypeName: any
    serviceName: any
    currencyTypeName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetAmbarAgreementSchemeListPagingAndFilterResponseData: GetAmbarAgreementSchemeListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}